import * as React from "react";
const SvgFiRrDiaryBookmarkDown = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M17 0H7C4.243 0 2 2.243 2 5v15c0 1.137.486 2.224 1.333 2.981a.999.999 0 1 0 1.334-1.49A2.002 2.002 0 0 1 6 18h.006l.032 5.347c0 .623.791.89 1.169.395l1.331-1.743 1.331 1.743c.378.495 1.169.228 1.169-.395L11.006 18H20v1c0 1.654-1.346 3-3 3h-3a1 1 0 1 0 0 2h3c2.757 0 5-2.243 5-5V5c0-2.757-2.243-5-5-5M4 16.537V5c0-1.304.836-2.415 2-2.828V16a4 4 0 0 0-2 .537M8 16V2h9c1.654 0 3 1.346 3 3v11z"
    />
  </svg>
);
export default SvgFiRrDiaryBookmarkDown;
